function postToWebsite(contents: Map<string, string>): Promise<Response> {
  let get_string = "?";
  contents.forEach((value: string, key: string) => {
    get_string += key + "=" + value + "&";
    console.log(key, value);
  });
  return fetch("https://factcompare.com/" + get_string, {
    method: "GET",
    mode: "no-cors",
  });
}

export { postToWebsite };
